module.exports = __webpack_public_path__ + "img/dddtl-ft-logo.c8053309.png";